import { PerformanceStage } from '../../api/models'

export const STAGE_LABELS: Record<PerformanceStage, string> = {
  prep: 'Preparation',
  search: 'Search',
  rerank: 'Rerank',
  context: 'Context build',
  answer: 'Answer generation',
}

export type OutcomeGroup = 'success' | 'refused' | 'failure'

export const OUTCOME_GROUPS: Record<OutcomeGroup, { label: string; color: string }> = {
  success: { label: 'Success', color: '#5B8A72' },
  refused: { label: 'Returned as success but refused', color: '#B7802A' },
  failure: { label: 'Failure', color: '#D4775B' },
}

const OUTCOME_DEFINITIONS: Record<string, { label: string; group: OutcomeGroup }> = {
  ok: { label: 'Answered', group: 'success' },
  no_answer: { label: 'No answer', group: 'refused' },
  privacy_block: { label: 'Privacy block', group: 'refused' },
  governance_block: { label: 'Governance block', group: 'refused' },
  abandoned: { label: 'Abandoned', group: 'failure' },
  error: { label: 'Error', group: 'failure' },
  retrieval_error: { label: 'Retrieval error', group: 'failure' },
  no_plan: { label: 'No plan', group: 'failure' },
  no_documents: { label: 'No documents', group: 'failure' },
}

const humanizeStatus = (status: string): string => {
  const words = status.replace(/_/g, ' ').trim()
  return words.charAt(0).toUpperCase() + words.slice(1)
}

export const outcomeLabel = (status: string): string => OUTCOME_DEFINITIONS[status]?.label ?? humanizeStatus(status)

export const outcomeGroup = (status: string): OutcomeGroup => OUTCOME_DEFINITIONS[status]?.group ?? 'failure'
